// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .professional-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
}
 
.professional-card {
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  overflow: hidden;
}
 
.professional-tabs .nav-link {
  border: none;
  border-radius: 8px 8px 0 0;
  padding: 12px 24px;
  font-weight: 500;
  color: #64748b;
  background: #f8fafc;
  margin-right: 4px;
  transition: all 0.3s ease;
}
 
.professional-tabs .nav-link:hover {
  background: #e2e8f0;
  color: #475569;
  transform: translateY(-1px);
}
 
.professional-tabs .nav-link.active {
  background: white;
  color: #1e293b;
  font-weight: 600;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
}
 
.stats-badge {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  font-size: 0.75rem;
  padding: 4px 12px;
}
 
.limit-indicator {
  background: rgba(255, 255, 255, 0.15);
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 0.8rem;
}
 
.company-info {
  background: rgba(255, 255, 255, 0.1);
  padding: 16px;
  border-radius: 8px;
  margin-top: 12px;
} */`, "",{"version":3,"sources":["webpack://./src/Component/OtherPages/Participation/ParticipationManagement/StaffCarManagementList.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyDG","sourcesContent":["/* .professional-header {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  border: none;\r\n  color: white;\r\n}\r\n \r\n.professional-card {\r\n  border: none;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n}\r\n \r\n.professional-tabs .nav-link {\r\n  border: none;\r\n  border-radius: 8px 8px 0 0;\r\n  padding: 12px 24px;\r\n  font-weight: 500;\r\n  color: #64748b;\r\n  background: #f8fafc;\r\n  margin-right: 4px;\r\n  transition: all 0.3s ease;\r\n}\r\n \r\n.professional-tabs .nav-link:hover {\r\n  background: #e2e8f0;\r\n  color: #475569;\r\n  transform: translateY(-1px);\r\n}\r\n \r\n.professional-tabs .nav-link.active {\r\n  background: white;\r\n  color: #1e293b;\r\n  font-weight: 600;\r\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n \r\n.stats-badge {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n  border: 1px solid rgba(255, 255, 255, 0.3);\r\n  font-size: 0.75rem;\r\n  padding: 4px 12px;\r\n}\r\n \r\n.limit-indicator {\r\n  background: rgba(255, 255, 255, 0.15);\r\n  padding: 8px 12px;\r\n  border-radius: 6px;\r\n  font-size: 0.8rem;\r\n}\r\n \r\n.company-info {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  padding: 16px;\r\n  border-radius: 8px;\r\n  margin-top: 12px;\r\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
